import type { FaireProductEntity } from "../../entity_types/product";

export const p_fhqnr62986: FaireProductEntity = {
  token: "p_fhqnr62986",
  type: "product",
  name: "Amélia Trio Dark Green Ring | Jewelry Gold Gift Waterproof",
  brandToken: "b_2rh5jwjkzg",
  brandName: "Agapée Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/07e3645e94f68475a53084baf329a4d6b71ed7c7669e7d6679fc4d1dc446af27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1eaafad74447d72d0dcea705ba061df9bcdebe17818876ea0a3f50897becad0.jpeg",
    "https://cdn.faire.com/fastly/6e54c7dd958a2a593da2069c72ac4c84aed6272738e1f0db9ef610488d996599.jpeg",
    "https://cdn.faire.com/fastly/55a225b3d194893e66b3c4894af91750202e88735f2da7a4e5c5f527d1ed32af.jpeg",
    "https://cdn.faire.com/fastly/2dc785a6d3c769fbd9777019946fe8131d691d476bf7fe351c7891854c9fbd1b.jpeg",
    "https://cdn.faire.com/fastly/6557ce61c36cc22b030fb6912598e30cf2c27be4621c6a01a841035a7f9bdaed.jpeg",
  ],
  priceDollars: 64,
  description:
    "Our Amélia Trio is made up of three stacked Amélia rings, for a fiercer look. Beaded with multiple stones embedded in gold, the geometric design of this ring catches and reflects light, making you shine brightly.\nCrafted from brass, plated with 18-carat gold. An alloy of copper and zinc, selected for its durability. Nickel-free, lead-free and hypoallergenic.\n\n18K gold-plated brass (2.5 microns)\nStone: Cubic zirconia\nColor: Olive\nRing width: 11 mm / 0.43 in\nAdjustable size: Yes\nRing inside diameter: 15.9 mm - 18.5 mm (0.63 in - 0.73 in)",
  tags: [],
  msrpDollars: 128,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:59.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
